/** Адрес мастера заявки: на него же возвращается посетитель после регистрации. */
export const requestWizardPath = '/fulfillment/request/new'

/** Адрес правки своей заявки: используется и маршрутом, и возвратом после повторного входа. */
export const requestWizardEditPath = (requestId: string) => `/fulfillment/request/${requestId}/edit`

/**
 * Сколько городов и складов бэкенд принимает в одной заявке. Считается по всей заявке, а не по
 * площадке. Больше он не примет, поэтому форма не даёт набрать лишнее: о пределе человек должен
 * узнать сразу, а не после того как заполнил заявку целиком. Источник чисел — Assert\Count в
 * FulfillmentRequestSaveRequest.php на бэкенде.
 */
export const maxRequestCityCount = 20
export const maxRequestWarehouseCount = 50
